module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menulist"
  }, [_c('transition', {
    attrs: {
      "name": "sideUp"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    ref: "content",
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-wrapper"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.menuList.title) + "\n        ")]), _vm._v(" "), _vm._l((_vm.menuList.content), function(item, index) {
    return _c('type-list', {
      key: index,
      staticClass: "tips-ok",
      attrs: {
        "item": item,
        "index": index,
        "name": item.name,
        "action": item.action,
        "icon": item.iconInfo,
        "clickItem": _vm.clickItem,
        "color": item.color
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tips-cancle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.hideMenuList($event)
      }
    }
  }, [_vm._v("取消")])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sideUp"
    }
  }, [_c('confirm-tips', {
    attrs: {
      "tipTitle": _vm.tipTitle,
      "clickCallBack": _vm.deleteFile,
      "tipsType": _vm.tipsType
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sideUp"
    }
  }, [_c('confirm-tips', {
    attrs: {
      "tipTitle": _vm.deliveryTip,
      "clickCallBack": _vm.cancelDelivery,
      "tipsType": _vm.deliveryType
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    staticClass: "mask",
    on: {
      "click": _vm.hideMenuList,
      "touchmove": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.stopTouch($event)
      }
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6444ef4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/menu_current_file.vue
// module id = 221
// module chunks = 3